import { RepositoryFactory as Repo } from "../../repository/RepositoryFactory";
const Offer = Repo.get("offer");

import {
  FETCH_OFFER_LOADING,
  FETCH_OFFER_ORDER_SUCCESS,
  FETCH_OFFER_FAILURE,
  FETCH_OFFER_SUCCESS,
  FETCH_OFFER_CONVERSATION_SUCCESS
} from "./mutation_types";

const state = {
  offers: {
    mdCount: 0,
    mdPage: 1,
    mdData: [],
    mdPerPage: 24
  },
  conversation: [],
  loading: false,
  errors: []
};

const getters = {
  offers(state) {
    return state.offers;
  },
  conversations(state) {
    return state.conversation;
  },
  loading(state) {
    return state.loading;
  }
};

const mutations = {
  [FETCH_OFFER_LOADING](state, data) {
    state.loading = data;
  },

  [FETCH_OFFER_SUCCESS](state, data) {
    state.offers = data;
  },
  [FETCH_OFFER_FAILURE](state, data) {
    state.errors = data;
  },

  [FETCH_OFFER_CONVERSATION_SUCCESS](state, data) {
    state.conversation = data;
  }
};

const actions = {
  async getOffers({ commit }) {
    try {
      commit(FETCH_OFFER_LOADING, true);

      const {
        data: { total, data, current_page }
      } = await Offer.getOffers();

      commit(FETCH_OFFER_SUCCESS, {
        mdCount: total,
        mdPage: current_page,
        mdData: data
      });
      commit(FETCH_OFFER_LOADING, false);
      return data;
    } catch (error) {
      commit(FETCH_OFFER_FAILURE, false);
    }
  },
  async getConversations({ commit }, id) {
    try {
      commit(FETCH_OFFER_LOADING, true);
      const { data } = await Offer.getConversations(id);

      commit(FETCH_OFFER_CONVERSATION_SUCCESS, data);
      commit(FETCH_OFFER_LOADING, false);
      return data;
    } catch (error) {
      commit(FETCH_OFFER_FAILURE, false);
    }
  },
  async updateOfferStatus({ commit }, data) {
    try {
      await Offer.updateOfferStatus(data.id);
      return Promise.resolve(true);
    } catch (err) {
      return Promise.reject(err);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
